import React, { Component } from "react";
import axios from "axios";
import { BrowserRouter, Route, Navigate } from "react-router-dom";
import { Panel } from "primereact/panel";
import Server from "./../Server.js";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { confirmAlert } from "react-confirm-alert";
import { AutoComplete } from "primereact/autocomplete";
import { Tag } from "primereact/tag";
import { connect } from "react-redux";
import { Loader } from "rsuite";
import { Toast } from "primereact/toast";
import { Multiselect } from "multiselect-react-dropdown";

class SessionList extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();

    this.CreateForm = this.CreateForm.bind(this);

    this.state = {
      layout: "list",
      name: "",
      ShopsList: [],
      type: "1",
      FId: "",
      usersList: [],
      permition: [],
    };
  }

  componentDidMount() {
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1,
    });
    let that = this;

    let SCallBack = function (response) {
      that.setState({
        user_Id: response.data.authData.userId,
        username: response.data.authData.username,
        loading: 0,
      });
      that.getPermition(response.data.authData.userId);
      that.getSessionList(response.data.authData.username);
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack);
  }
  getPermition(user_Id) {
    let param = {
      token: localStorage.getItem("api_token"),
      userId: user_Id,
      systemId: this.props.systemId
    };

    let that = this;
    let SCallBack = function (response) {
      const permition =
        response.data.result[0] && response.data.result[0].permitions["209"]
          ? response.data.result[0].permitions["209"]
          : [];
      that.setState({
        loading: 0,
        permition: permition,
      });
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("AdminApi/getPermition", param, SCallBack, ECallBack);
  }

  CreateForm() {
    this.setState({
      visibleManageField: true,
      fTitle: "",
      enable: true,
      lTitle: "",
      father: "",
      usersList: [],
      system: null,
      selectedId: null,
    });
  }

  selectedComponentChange(value) {
    let that = this;
    var p = [];
    this.setState({
      fTitle: value.fTitle,
      lTitle: value.lTitle,
      father: value.father,
      enable: value.enable,
      usersList: value.usersList,
      system: value.system,
      selectedId: value._id,
      visibleManageField: true,
    });
  }
  getSessionList(username, all) {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      username: !all ? username || this.state.username : null,
      GetAll: 1,
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      for (let i = 0; i < response.data.result.length; i++) {
        response.data.result[i].browserName =
          response.data.result[i].session &&
          response.data.result[i].session.browser
            ? response.data.result[i].session.browser.browserName
            : "";
        response.data.result[i].fullVersion =
          response.data.result[i].session &&
          response.data.result[i].session.browser
            ? response.data.result[i].session.browser.fullVersion
            : "";
        response.data.result[i].userAgent =
          response.data.result[i].session &&
          response.data.result[i].session.browser
            ? response.data.result[i].session.browser.userAgent
            : "";
      }
      that.setState({
        GridDataFields: response.data.result,
      });
      that.setState({
        loading: 0,
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("MainApi/getSessionList", param, SCallBack, ECallBack);
  }
  delField(rowData) {
    this.setState({
      visibleManageField: false,
    });
    confirmAlert({
      title: <span className="yekan">حذف کاربر</span>,
      message: (
        <span className="yekan"> آیا از حذف {rowData.name} مطمئنید </span>
      ),
      buttons: [
        {
          label: <span className="yekan">بله </span>,
          onClick: () => {
            let that = this;
            let param = {
              token: localStorage.getItem("api_token"),
              _id: rowData._id,
            };
            let SCallBack = function (response) {
              that.setState({
                loading: 0,
              });
              that.getSessionList(null, that.state.getAll);
              that.toast.current.show({
                severity: "success",
                summary: "",
                detail: "عملیات با موفقیت انجام شد",
                life: 3000,
              });
            };
            let ECallBack = function (error) {
              that.setState({
                loading: 0,
              });
              that.toast.current.show({
                severity: "error",
                summary: "خطای سرور",
                detail: "عملیات انجام نشد",
                life: 3000,
              });
            };
            this.Server.send(
              "MainApi/delSessionList",
              param,
              SCallBack,
              ECallBack
            );
          },
        },
        {
          label: <span className="yekan">خیر </span>,
        },
      ],
    });
  }
  render() {
    const delTemplate = (rowData, props) => {
      return (
        <i
          className="fa fa-times"
          style={{ cursor: "pointer" }}
          aria-hidden="true"
          onClick={(event) => {
            this.delField(rowData);
            event.stopPropagation();
          }}
        ></i>
      );
    };
    const appTemplate = (rowData, props) => {
      if (rowData.session.inApp) {
        return (
          <div>
            <Tag
              severity="primary"
              value={
                <div
                  style={{
                    width: 70,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <i className="fa fa-mobile"></i>
                  <span>اپلیکیشن</span>
                </div>
              }
            ></Tag>
          </div>
        );
      } else {
        return (
          <div>
            <Tag
              severity="info"
              value={
                <div
                  style={{
                    width: 70,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <i className="fa fa-desktop"></i>
                  <span>وب</span>
                </div>
              }
            ></Tag>
          </div>
        );
      }
    };
    const nameTemplate = (rowData, props) => {
      return (
        <div>
          {rowData.users && rowData.users[0] && rowData.users[0].name
            ? rowData.users[0].name
            : "-"}
        </div>
      );
    };

    return (
      <div style={{ direction: "rtl" }}>
        {this.state.loading == 1 && (
          <div
            style={{
              position: "fixed",
              zIndex: 2000,
              top: 10,
              left: 15,
              backgroundColor: "#e89f31",
              padding: "2px 20px",
            }}
          >
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        )}
        <div className="row justify-content-center mt-2">
          <div className="col-12" style={{ background: "#fff" }}>
            {this.state.permition.some((item) => {
              return item == 1;
            }) && (
              <div>
                <div>
                  <div className="group">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "end",
                      }}
                    >
                      <Checkbox
                        inputId="active"
                        value={this.state.getAll}
                        checked={this.state.getAll}
                        onChange={(e) => {
                          this.setState({
                            getAll: e.checked,
                          });
                          this.getSessionList(null, e.checked);
                        }}
                      ></Checkbox>
                      <label
                        htmlFor="active"
                        className="p-checkbox-label yekan"
                        style={{ paddingRight: 5, marginBottom: 0 }}
                      >
                        همه کاربران آنلاین
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <Panel
              header="لیست سشن های فعال"
              style={{ textAlign: "right", fontFamily: "yekan" }}
            >
              <DataTable
                responsive
                stripedRows
                value={this.state.GridDataFields}
                selectionMode="single"
                selection={this.state.selectedComponent}
                onSelectionChange={(e) => this.selectedComponentChange(e.value)}
              >
                <Column
                  field="session.user"
                  header="نام کاربری"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="name"
                  header="نام"
                  body={nameTemplate}
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="inApp"
                  body={appTemplate}
                  header="پلتفرم"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="session.day"
                  header="روز ورود"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="session.time"
                  header="ساعت ورود"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="del"
                  body={delTemplate}
                  header="حذف"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
              </DataTable>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(SessionList);
